import z from 'zod'

export const WhatsUpSchema = z.object({
  phoneVerificationRequired: z.boolean().optional(),
  statusMessage: z
    .object({
      isBlocking: z.boolean(),
      title: z.string(),
      text: z.string(),
      imageId: z.string().nullish(),
    })
    .nullable(),
})

export type WhatsUpResponse = z.infer<typeof WhatsUpSchema>
